
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { VehicleCheck } from './../model/compliance.model';
import { DriverFitnessTest } from './../model/compliance.model';
import { Url } from '../model/users.model';

@Injectable()
export class ComplianceService {
    @LocalStorage() url: Url;
    private headers = new Headers({ 'Content-Type': 'application/json' });
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public http:HttpClient) {
    
    }

    getMassManagementList() {
		return this.http.get(this.url.rest  + '/tms/getMassManagementList', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

	getVehicleChecks(): Observable<VehicleCheck[]> {
		return this.http.get<VehicleCheck[]>(this.url.rest  + '/tms/getVehicleTests', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getOverview() {
        return this.http.get(this.url.rest + "/tms/getComplianceOverviewData")
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    getVehicleCheck(id:number): Observable<VehicleCheck> {
        return this.http.get<VehicleCheck>(this.url.rest  + '/tms/getVehicleTest/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createVehicleCheck(vehicle_test:VehicleCheck): Observable<VehicleCheck> {
    	return this.http.post<VehicleCheck>(this.url.rest  + '/tms/createVehicleTest', vehicle_test , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateVehicleCheck(vehicle_test:VehicleCheck): Observable<VehicleCheck> {
        return this.http.put<VehicleCheck>(this.url.rest  +  '/tms/updateVehicleTest', vehicle_test , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteVehicleCheck(id: number): Observable<any[]> {
        return this.http.delete<any[]>(this.url.rest  +  '/tms/deleteVehicleTest/' + id , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getDriverFitnessTests(): Observable<DriverFitnessTest[]> {
        return this.http.get<DriverFitnessTest[]>(this.url.rest  +  '/tms/getDriverFitnessTests', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getDriverFitnessTest(id:number): Observable<DriverFitnessTest> {
        return this.http.get<DriverFitnessTest>(this.url.rest  + '/tms/getDriverFitnessTest' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createDriverFitnessTest(dft:DriverFitnessTest): Observable<DriverFitnessTest> {
        return this.http.post<DriverFitnessTest>(this.url.rest  +  '/tms/createDriverFitnessTest', dft , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateDriverFitnessTest(dft:DriverFitnessTest): Observable<DriverFitnessTest> {
        return this.http.put<DriverFitnessTest>(this.url.rest  +  '/tms/updateDriverFitnessTest', dft , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteDriverFitnessTest(id: number): Observable<any[]> {
        return this.http.delete<any[]>(this.url.rest  +  '/tms/deleteDriverFitnessTest/' + id , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}